<template>
    <div class="form__field">

        <div class="user-image" v-for="(image, i) in images" :key="`file-uploaded-${i}`">
            <img :src="image.preview" />
            <input type="text" v-model="image.caption" name="images" class="js-dropzone-caption" placeholder="Add a caption (optional)"/>
            <button type="button" @click="removeImage(i)" class="btn-remove-img">
                <svg class="close"><use xlink:href="#close"></use></svg>
            </button>
        </div>

        <div class="submit-images-main" @dragover="dragover" @dragleave="dragleave" @drop="drop" ref="dropzone">

            <div v-if="isLoading">
                <h3 class="loading">Loading Images...</h3>
                <Spinner></Spinner>
            </div>

            <div v-else>
                <input id="images" type="file" multiple accept=".jpg,.jpeg,.png, .heic" ref="file" @change="handleChange"/>

                <h3 class="on-mobile">Add some photos here</h3>
                <h3 class="on-desktop">Drag and drop photos here</h3>

                <p>
                    or
                    <span class="button button--override">
                        Choose Files
                    </span>
                    <span v-if="images.length" class="button button--remove" @click="clearFileList">
                        Remove All Images
                    </span>
                </p>
            </div>
        </div>

        <span class="error" v-if="error" v-text="error"></span>
    </div>
</template>

<script>

import heic2any from 'heic2any'
import Spinner from '@/components/Spinner'

  export default {

      props: {
          value: {
              type: Array,
          },
      },

      components:{
          Spinner
      },

      data() {
          return {
              images: this.value,
              isLoading: false,
              error: null,
          }
      },

      created() {
          if (eventBus) {
              eventBus.$on('reset-form-dropzone', () => {
                  this.images = []
                  this.isLoading = false
                  this.error = null
              })
          }
      },

      methods: {

          async handleChange() {

              let {files} = this.$refs.file

              files = _.filter(files, file => {
                  return ['image/jpg', 'image/jpeg', 'image/png', 'image/heic'].includes(file.type);
              });

              if (!files.length) return false

              this.isLoading = true
              this.error = null

              const fileNames = this.uploadTempImages(files)
          },

          async getPreviewImage(file) {
              const img = file.type.includes('heic') ? await this.convertHeicToJpeg(file) : file
              return await URL.createObjectURL(img)
          },

          async uploadTempImages(files) {

              let totaCompletedlUploads = 0

              for (let file of Array.from(files)) {

                  const formData = new FormData()
                  const img = file.type.includes('heic') ? await this.convertHeicToJpeg(file) : file
                  formData.append('image', img, img.name)

                  axios.post('/dropzone', formData)
                      .then(response => {
                          this.images.push({
                              caption: '',
                              file: response.data.path,
                              preview: URL.createObjectURL(img)
                          })

                          totaCompletedlUploads++;
                          if (totaCompletedlUploads == files.length) {
                              this.isLoading = false
                          }
                      })
                      .catch(errors => {
                          this.error = errors.response.data.message
                          this.isLoading = false
                      })
              }
          },

          convertHeicToJpeg(file) {
              return new Promise(resolve => {
                  resolve(
                      heic2any({
                          blob: file,
                          toType: 'image/jpeg',
                          quality: 0.8,
                      })
                  )
              })
          },

          clearFileList() {
              this.$refs.file.value = ''
              this.error = null
              this.images = []
              // const $hiddenFiles = document.querySelectorAll('.js-hidden-filenames')
              // $hiddenFiles.forEach(el => el.remove())
              this.handleChange()
              this.isLoading = false
          },


          dragover(e) {
              e.preventDefault()
              // Add some visual fluff to show the user can drop its files
              if (!this.$refs.dropzone.classList.contains('bg-green-300')) {
                  this.$refs.dropzone.classList.remove('bg-gray-100')
                  this.$refs.dropzone.classList.add('bg-green-300')
              }
          },

          dragleave(e) {
              // Clean up
              this.$refs.dropzone.classList.add('bg-gray-100')
              this.$refs.dropzone.classList.remove('bg-green-300')
          },

          drop(e) {
              e.preventDefault()

              this.$refs.file.files = e.dataTransfer.files

              this.handleChange() // Trigger the onChange event manually

              // Clean up
              this.$refs.dropzone.classList.add('bg-gray-100')
              this.$refs.dropzone.classList.remove('bg-green-300')
          },

          removeImage(index) {
              this.images.splice(index, 1)
          }
      },

      watch: {
          isLoading(value) {
              this.$emit('uploadImagesStatus', value)
          }
      }
  }
</script>
